/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const PLANOGRAM_FRAGMENT = gql`
  fragment Planogram on Planogram {
    id
    shapedUpcs
  }
`
